import { ReactNode } from 'react'
import { cn } from '../lib/cn'

interface KeyValueListProps {
  items: { label: string; value: ReactNode }[]
  columns?: 1 | 2 | 3
  className?: string
  labelClassName?: string
}

const columnsClassName: Record<
  NonNullable<KeyValueListProps['columns']>,
  string
> = {
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3',
}

export const KeyValueList = ({
  items,
  columns = 2,
  className,
  labelClassName,
}: KeyValueListProps) => (
  <dl
    className={cn('grid gap-x-6 gap-y-2', columnsClassName[columns], className)}
  >
    {items.map((item) => (
      <div key={item.label} className='break-inside-avoid'>
        <dt
          className={cn(
            'text-[8pt] uppercase tracking-wide text-zinc-500',
            labelClassName,
          )}
        >
          {item.label}
        </dt>
        <dd className='font-medium'>{item.value}</dd>
      </div>
    ))}
  </dl>
)
